import React from "react";

import CrossProjectTaskBoard from "../projects/components/TaskBoard/CrossProjectTaskBoard";

/**
 * 横断タスクボードの独立ページ（`/taskboard`）。グローバルメニュー「TASK」の遷移先。
 *
 * 本体は `CrossProjectTaskBoard`。上部のセグメント行（タスク / スケジュール /
 * 工数 / 検索）はプロジェクトリストと同じく wrapper の外（全幅）に
 * 置くため、wrapper は本体側が持つ。
 * `?project=<id>` 付きなら単一プロジェクトの絞り込み表示、
 * `?view=gantt|activity` で表示ビューの直リンクができる。
 */
const TaskBoardPage: React.FC = () => (
  <div className="u-col-center">
    <CrossProjectTaskBoard />
  </div>
);

export default TaskBoardPage;
